module.exports = __webpack_public_path__ + "img/data_model.60d80c16.png";